export default __webpack_public_path__ + "static/media/himalaya.03191b2d.JPG";